import React from 'react';

const IconRP = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_4774_384069)">
        <circle cx="12" cy="12" r="12" fill="#3A83F9" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.4161 14.213C11.5875 14.4356 11.7433 14.6744 11.7433 15.0353C11.7433 15.6867 11.21 16.095 10.6877 16.095C10.2025 16.095 9.88398 15.8447 9.65724 15.548L8.12266 13.5562H7.1975V14.9691C7.1975 15.5961 6.71068 16.095 6.09875 16.095C5.48682 16.095 5 15.5961 5 14.9691V8.87591C5 8.24885 5.48682 7.75 6.09875 7.75H8.71637C9.72392 7.75 10.5443 8.04069 11.1043 8.61455C11.5835 9.10556 11.8295 9.7875 11.8295 10.5758V10.5979C11.8295 11.2527 11.6691 11.8008 11.3708 12.2413C11.1404 12.5815 10.8351 12.8466 10.4789 13.0461L11.4161 14.213ZM7.1975 9.83624V11.503H8.60865C8.96668 11.503 9.2158 11.4054 9.37118 11.2679C9.52241 11.1341 9.61045 10.9406 9.61045 10.6862V10.6641C9.61045 10.3697 9.51376 10.1786 9.36247 10.0542C9.20204 9.92233 8.94442 9.83624 8.57633 9.83624H7.1975ZM13.4847 17.8611C12.8835 17.8611 12.3967 17.3623 12.3967 16.7462V10.6089C12.3967 9.99291 12.8835 9.49406 13.4847 9.49406C13.9064 9.49406 14.2718 9.73951 14.4524 10.0987C14.8566 9.71249 15.3861 9.4499 16.1023 9.4499C17.6057 9.4499 19 10.6637 19 12.7835V12.8056C19 13.8556 18.6638 14.6916 18.1235 15.2667C17.5845 15.8405 16.8563 16.1391 16.1023 16.1391C15.444 16.1391 14.9527 15.9272 14.5727 15.6298V16.7462C14.5727 17.3623 14.0859 17.8611 13.4847 17.8611ZM14.5511 12.8056C14.5511 13.6597 15.0886 14.1633 15.6822 14.1633C16.2795 14.1633 16.824 13.6666 16.824 12.8056V12.7835C16.824 11.9322 16.2783 11.4258 15.6822 11.4258C15.0886 11.4258 14.5511 11.9293 14.5511 12.7835V12.8056Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_4774_384069">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default IconRP;
